import React from "react"
import SingleLink from "./SingleLink"
import LinkList from "./LinkList"

const MobileLink = ({
  link,
  setIsBespokeOpen,
  isBespokeOpen,
  closeIfActive }) => {
  const handleBespokeFormPopup = () => {
    if (!isBespokeOpen) {
      setIsBespokeOpen(true)
    }
  }

  const updateLinkData = (link) => {
    let activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development";

    activeEnv = activeEnv.toLowerCase();

    const countryPrefixes = ['uk', 'eu', 'fr'];

    let linkData = Object.assign({}, link);

    if (countryPrefixes.includes(activeEnv)) {
      if (linkData.externalLink) {
        linkData.externalLink = getNewLinkValue(activeEnv, link.externalLink);
      } 
      
      if (linkData.link) {
        linkData.externalLink = getNewLinkValue(activeEnv, link.link);
      }
    }

    return linkData;
  }

  const getNewLinkValue = (activeEnv, initialLink) => {
    let newLinkValue = initialLink;

    if (initialLink.includes('learn')) {
      return newLinkValue;
    }

    if (initialLink.includes('https://kimai.com')) {
      newLinkValue = newLinkValue.replace('https://kimai.com', `https://kimai.com/${activeEnv}`);
    } else if (!initialLink.includes('http')) {
      newLinkValue = `/${activeEnv}${initialLink}`;
    }

    return newLinkValue;
  }

  const linkType = link.__typename;

  switch (linkType) {
    case "ContentfulLink":
      const linkData = updateLinkData(link);

      return (
        <SingleLink
          link={linkData}
          handleBespokeFormPopup={handleBespokeFormPopup}
          closeIfActive={closeIfActive}
        />
      )
    case "ContentfulLinkList":
      let linksData = Object.assign({}, link);

      let linksArray = link.links;

      let updatedLinksArrayData = [];

      for (let i = 0; i < linksArray.length; i++) {
        const linksArrayData = linksArray[i].links;

        let topLevelObject = Object.assign({}, linksArray[i]);

        let topLevelLinks = [];

        for (let j = 0; j < linksArrayData.length; j++) {
          const linksArrayObject = linksArrayData[j];

          let linkArrayData = Object.assign({}, linksArrayObject);
        
          linkArrayData = updateLinkData(linksArrayObject);

          topLevelLinks.push(linkArrayData);
        }

        topLevelObject.links = topLevelLinks;

        updatedLinksArrayData.push(topLevelObject);
      }

      linksData.links = updatedLinksArrayData;

      return (
        <LinkList
          link={linksData}
          handleBespokeFormPopup={handleBespokeFormPopup}
          closeIfActive={closeIfActive}
        />
      )
    default:
      return null
  }
}

export default MobileLink
